export default __webpack_public_path__ + "static/child-piercing-1-97c97f126cc8b3405a7e2b8b1095fef7.jpeg";